/**
 * @generated SignedSource<<36e0af31105676d4c13fa1151311f4bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowWithDragAndDrop_issue$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowInner_issue">;
  readonly " $fragmentType": "row_nativeIssueTable_RowWithDragAndDrop_issue";
};
export type row_nativeIssueTable_RowWithDragAndDrop_issue$key = {
  readonly " $data"?: row_nativeIssueTable_RowWithDragAndDrop_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowWithDragAndDrop_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowWithDragAndDrop_issue",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowInner_issue"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "7a12c603dc5ac5fd96d9c3a48373491e";

export default node;
